import React, { forwardRef, memo, useCallback, useState } from 'react'
import DatePicker from "react-datepicker";
import Input from '../../UI/Input/Input';

import './DatePicker.css'
// for documenation of this : https://reactdatepicker.com/ 

const DatePick = ({placeholder,dateFormat="dd-MM-yyyy", required, className,style, ...rest}) => {
    const DateCustomInput = forwardRef(({ value, onClick,placeholder }, ref) => (
    <Input required={required} className={`datePicker-input ${className}`} style={style} placeholder={placeholder} onClick={onClick} ref={ref} value={value} />
    //need to define a prop which pass the data
));
  return (
    <>
      <DatePicker
      withPortal
      // selected={startDate}
      // onChange={(date) => {setStartDate(date);console.log(startDate)}}
      // onBlur={() => console.log(startDate)}
      placeholderText={placeholder}
      dateFormat={dateFormat}
      customInput={<DateCustomInput />}
      {...rest}
    />
    </>
  )
}

export default memo(DatePick)
